import script from "./transfer.vue?vue&type=script&setup=true&lang=js"
export * from "./transfer.vue?vue&type=script&setup=true&lang=js"

import "./transfer.vue?vue&type=style&index=0&id=3632c05d&scoped=true&lang=css"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3632c05d"]])

export default __exports__